<template>
  <div class="chat-user">
    <span
      class="status-icon"
      :class="myStatus"
    >
      <emitter v-if="sleepy" />
    </span>
    <router-link :to="{ name: 'profile', params: { id: user.id } }">
      {{ user.first_name ? user.first_name : '(Unknown)' }} {{ user.last_name }}<br>
    </router-link>
  </div>
</template>

<script>
import Emitter from '@virgodev/bazaar/components/Emitter.vue';
import TimerMixin from '@virgodev/bazaar/mixins/timer';

export default {
  name: 'ChatUser',
  components: {
    Emitter,
  },
  mixins: [
    TimerMixin,
  ],
  props: {
    user: { type: Object, required: true },
    status: { type: String, default: null },
  },
  computed: {
    sleepy() {
      const d = new Date(this.user.timestamp);
      const cutoff = this.now - this.$root.chatSleepTimeout;
      return this.myStatus !== 'offline' && d.getTime() < cutoff;
    },
    myStatus() {
      return this.status || this.user.status || 'offline';
    },
  },
};
</script>

<style lang="scss" scoped>
.chat-user {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1 auto;
}
.status-icon {
  flex: 0 0 auto;
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 2px 5px;
  border-radius: 50%;
  border: 1px solid grey;
}
.status-icon.offline {
  background: grey;
}
.status-icon.online {
  background: lightgreen;
  box-shadow: 0 0 2px darkgreen;
}
.status-icon.away {
  background: yellow;
  box-shadow: inset 0 0 3px orange;
}
a {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
